import {isStandaloneMesh} from '@/modules/CreateServiceMesh/CreateServiceMeshForm/util';
import {TServiceMeshType} from '@/modules/CreateServiceMesh/type';

export const isShowMultiProtocol = (type: TServiceMeshType, istioVersion: string) => {
    return isStandaloneMesh(type) && ['1.14.6', '1.16.5'].includes(istioVersion);
};
